module.exports = __webpack_public_path__ + "static/media/5DPO16.9ecb1c48.jpg";